module.exports = __webpack_public_path__ + "media/images/forms-icons/checkbox-icon-c8a0a1ab0c30f362b2d1d9c4b50c1be1.svg";